import { registerQuery } from 'data-fetching-client';
import { getPortalDemographicsRpc } from 'demographics-service-types';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getEarlyRequestResult } from '../utils/earlyRequest';
const rpcClientAuth = createRpcClientV2({
  hubHttpClient: http
});
export const GET_COMPANY_DETAILS = registerQuery({
  fieldName: 'companyDetails',
  fetcher() {
    return getEarlyRequestResult('companyDetails', () => rpcClientAuth.call(getPortalDemographicsRpc, {}));
  }
});